import React from 'react';

import styled, {css} from 'styled-components';
import {colorTheme} from '../../mixin/colorTheme';

import emptyPageDarkMode from '../../../img/vector/empty-state/page/Empty-state-vector-dark-mode.png';
import emptyPageLightMode from '../../../img/vector/empty-state/page/Empty-state-vector-light-mode.png';

/**
 * @param {object} param0
 *
 * @param {'sm'} [param0.size]
 * Use `size='sm'` to change the size of the empty state image.
 *
 * @param {React.ReactNode} param0.children
 *
 * **Here is how to use the component**
 * @example
 * <EmptyState>
 *     Insert your empty state message here
 *     (An image will automatically be placed on top of the text)
 * </EmptyState>
 */
export const EmptyState = ({size, children}) => {
    return (
        <EmptyStateWrapper>
            <EmptyIcon size={size} src={{light: emptyPageLightMode, dark: emptyPageDarkMode}} />
            <EmptyState.Txt>{children}</EmptyState.Txt>
        </EmptyStateWrapper>
    );
};

export const EmptyIcon = styled.div`
    ${({src}) =>
        colorTheme({
            '--currentLogo': {
                dark: `url(${src.dark})`,
                light: `url(${src.light})`,
            },
        })}
    background: var(--currentLogo);
    width: auto;
    opacity: 0.1;

    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    ${({size}) => {
        if (size === 'sm') {
            return css`
                height: 160px;
            `;
        } else {
            return css`
                height: 300px;
            `;
        }
    }}
`;

const EmptyStateWrapper = styled.div`
    padding-top: calc(var(--space-xxl) * 3);
    display: flex;
    flex-direction: column;
    gap: var(--space-xl);
`;

export const EmptyStateTxt = styled.span`
    color: var(--label-text-color);
    text-align: center;
`;

EmptyState.Txt = EmptyStateTxt;
EmptyState.Wrapper = EmptyStateWrapper;
